module.exports = __webpack_public_path__ + "img/align-3.49762585.svg";